// // @todo this file goes away in favor of the new convo store
//   actions: {
//     // NEW - POLLING LOGIC START
//     initiateConversationPolling(context, entityId) {
//       this.cancelConversationPolling();
//       this.pollingIntervalId = setInterval(() => {
//         this.fetchConversationPolling(context, entityId);
//       }, 3000); // Changed from 1000ms to 3000ms for better performance
//     },
//     cancelConversationPolling() {
//       if (this.isFetchingPolling) {
//         this.isFetchingPolling = false;
//       }
//       if (this.pollingIntervalId) {
//         clearInterval(this.pollingIntervalId);
//       }
//       if (this.isFetching && this.pollingXhr) {
//         this.pollingXhr.abort();
//       }
//     },
//     fetchConversationPolling(context, entityId, forcePolling = false) {
//       if (this.isFetchingPolling) {
//         return;
//       }
//       this.isFetchingPolling = true;
//       this.loadingMessages = false;
//       const lastPolled = Date.now() - this.lastPollingUpdate[this.conversationId];
//       const polledRestrictionInMinutes = 1000 * 60 * 15;
//       const shouldPoll = lastPolled < polledRestrictionInMinutes && this.messages.length;
//       if (forcePolling || shouldPoll) {
//         const apiUrl = context === "direct_message" ? `/conversation/${this.conversationId}/status` :
//           `/conversation/${context}/${entityId}/status`;
//         this.pollingXhr = this.apiGet(apiUrl,
//           {
//             last_polling_update: (this.lastPollingUpdate[this.conversationId] || 1000) - 1000,
//             visibility: useChannelStore().channel.visibility,
//           },
//           response => this.handlePollingUpdateResponse(response),
//           () => {
//             this.cancelConversationPolling();
//           },
//           () => {
//             this.isFetchingPolling = false;
//           });
//       } else {
//         this.lastMesssageId = Number.MAX_SAFE_INTEGER;
//         this.lastSortId = Number.MAX_SAFE_INTEGER;
//         if (this.conversation.context === "publication_chatroom") {
//           this.fetchPublicationChatroom(this.conversationId, false);
//         } else {
//           this.fetchConversation(this.conversationId, this.conversation.context, this.conversation.entity_id, "desc", false);
//         }
//       }
//     },
//     handlePollingUpdateResponse(data) {
//       this.lastPollingUpdate[this.conversationId] = Date.now();
//       this.conversation = data["conversation"];
//       this.conversations = data["conversations"];
//       data["messages"].forEach(message => {
//         this.addOrReplaceMessage(message, true);
//       });
//       useChannelStore().channels = data["channels"] ?? [];
//     },
//     recalculateSeenStatus() {
//       // check each message in messages against the unseenMentionForViewerMessages
//       const recalculatedUnsetStatus = [];
//       this.unseenMentionForViewerMessages.forEach(messageId => {
//         if (this.allMessages[messageId]) {
//           if (this.allMessages[messageId].containsUnreadMentionForViewer) {
//             recalculatedUnsetStatus.push(messageId);
//           }
//         }
//       });
//       this.unseenMentionForViewerMessages = recalculatedUnsetStatus;
//     },
//     // NEW - POLLING LOGIC END
//
//
//     getLinkPreviewData(url, successCallback = () => {
//     }, errorCallback = () => {
//     }) {
//       this.isLinkPreviewLoading = true;
//
//       this.apiGet(
//         "/conversation/link-preview",
//         { url },
//         data => {
//           this.isLinkPreviewLoading = false;
//           successCallback(data.link_preview_data);
//         },
//         error => {
//           this.isLinkPreviewLoading = false;
//           errorCallback(error);
//         },
//       );
//     },
//     markMentionsAsSeenForMessage(messageId) {
//       this.apiPost(`/message/${messageId}/mentions/seen`, {}, response => {
//         this.conversation = response["conversation_data"];
//
//         response["messages"].forEach(message => {
//           this.addOrReplaceMessage(message);
//         });
//       });
//     },
//     markConversationAsRead(conversationId) {
//       this.apiPost(`/conversation/${conversationId}/read`, {}, () => {
//         // Success callback - no need to handle response data
//       });
//     },
//     async getMessage(messageId) {
//       this.loadingMessage = true;
//       await this.apiGet(
//         `/message/${messageId}`,
//         {},
//         data => {
//           this.updateConversation(data.conversation_data, data.messages, data.metadata);
//           this.message = data;
//           this.loadingMessage = false;
//         },
//         () => {
//           this.loadingMessage = false;
//         },
//       );
//     },
//     getPageOfMessageReplies(storyId, messageId) {
//       this.loadingReplies = true;
//       this.apiGet(
//         `/story/${storyId}/comments/${messageId}/replies`,
//         {
//           limit: this.pageLimit,
//           sort_direction: this.sortDirection,
//           sort_strategy: this.sortStrategy,
//           last_message_id: this.lastMessageId,
//           last_sort_id: this.lastSortId,
//
//         },
//         data => {
//           this.updateConversation(data.conversation_data, data.messages, data.metadata);
//           this.hasMoreMessages = data.messages.length !== 0;
//           this.loadingReplies = false;
//         },
//         () => {
//           this.loadingReplies = false;
//         },
//       );
//     },
//     fetchPublicationChatroom(publicationId, toggleLoading = true) {
//       let uri = `/conversation/publication-chatroom/${publicationId}`;
//       if (this.loadingMessages) {
//         return;
//       }
//
//       if (toggleLoading) {
//         this.loadingMessages = true;
//       }
//       this.apiGet(
//         uri,
//         {
//           limit: this.pageLimit,
//           sort_direction: this.sortDirection,
//           sort_strategy: this.sortStrategy,
//           last_message_id: this.lastMessageId,
//           last_sort_id: this.lastSortId,
//           // include_deleted_messages: this.includeDeletedMessages,
//         },
//         data => {
//           this.updateConversation(data.conversationData, data.messages, data.metadata);
//           this.loadingMessages = false;
//           if (data.messages.length > 0) {
//             this.hasMoreMessages = true;
//           } else {
//             this.hasMoreMessages = false;
//           }
//
//           this.lastPollingUpdate[this.conversationId] = Date.now();
//           this.initiateConversationPolling("publication_chatroom", publicationId);
//         },
//         () => {
//           this.loadingMessages = false;
//           this.hasMoreMessages = false;
//         },
//       );
//     },
//     sendPublicationChatroomMessage(publicationId) {
//       let uri = `/conversation/publication-chatroom/${publicationId}/message`;
//
//       if (!this.isMessageLoading.newMessage) {
//         this.isMessageLoading.newMessage = {};
//       }
//       this.isMessageLoading.newMessage = true;
//       this.apiPost(
//         uri,
//         {
//           message: this.draftMessage,
//           moderation_strategy: this.moderationStrategy,
//         },
//         response => {
//           this.updateConversation(response.conversationData, response.messages, response.metadata, true);
//         },
//         null,
//         () => {
//           this.isMessageLoading.newMessage = false;
//         },
//       );
//     },
//     fetchConversation(conversationId, context, entityId, sortDirection = "desc", toggleLoading = true) {
//       let uri = `/story/${entityId}/comments`;
//       if (conversationId > 0) {
//         uri = `/conversation/${conversationId}`;
//       }
//
//       if (this.loadingMessages) {
//         return;
//       }
//       if (toggleLoading) {
//         this.loadingMessages = true;
//       }
//       this.apiGet(
//         this.creatorApiV1 + uri,
//         {
//           limit: this.pageLimit,
//           sort_direction: sortDirection || this.sortDirection,
//           sort_strategy: this.sortStrategy,
//           last_message_id: this.lastMessageId || undefined,
//           last_sort_id: this.lastSortId || Number.MAX_SAFE_INTEGER,
//           // include_deleted_messages: this.includeDeletedMessages,
//         },
//         data => {
//           this.updateConversation(data.conversationData, data.messages, data.metadata);
//           this.hasMoreMessages = data.messages.length !== 0;
//           this.loadingMessages = false;
//           if (context && entityId) {
//             this.lastPollingUpdate[this.conversationId] = Date.now();
//             this.initiateConversationPolling(context, entityId);
//           }
//         },
//         () => {
//           this.loadingMessages = false;
//           this.hasMoreMessages = false;
//         },
//       );
//     },
//
//     getConversationByEntity(context, entityId) {
//       if (this.loadingMessages) {
//         return;
//       }
//
//       this.loadingMessages = true;
//       this.apiGet(
//         `/conversation/context/${context}/${entityId}`,
//         {
//           limit: this.pageLimit,
//           sort_direction: this.sortDirection,
//           sort_strategy: this.sortStrategy,
//           last_message_id: this.lastMessageId || undefined,
//           last_sort_id: this.lastSortId || undefined,
//         },
//         data => {
//           this.updateConversation(data.conversationData, data.messages, data.metadata);
//           this.hasMoreMessages = data.messages.length !== 0;
//           this.loadingMessages = false;
//         },
//         () => {
//           this.loadingMessages = false;
//           this.hasMoreMessages = false;
//         },
//       );
//     },
//
//     handleReaction(reaction, messageId) {
//       const reactions = this.allMessages[messageId]?.reaction || [];
//       const existingReaction = reactions.find(reactionItem => {
//         return reactionItem.reaction === reaction &&
//             this.userData.user_id === (reactionItem.user_id || reactionItem.userId);
//       });
//       if (existingReaction) {
//         this.postToMessageEndpoint("revoke-reaction", messageId, { reaction_id: existingReaction.reaction_id || existingReaction.reactionId });
//       } else {
//         this.postToMessageEndpoint("react", messageId, { reaction: reaction });
//       }
//     },
//
//
//     addOrReplaceMessage(message, appendToFront = false) {
//       try {
//         message.segments = JSON.parse(message.message);
//       } catch (e) {
//         // do nothing
//       }
//
//       // change all the keys of 'message' to camelCase if it is not already
//       message = Object.keys(message).reduce((acc, key) => {
//         acc[key.replace(/_([a-z])/g, g => g[1].toUpperCase())] = message[key];
//         return acc;
//       }, {});
//
//       if (message["containsUnreadMentionForViewer"]) {
//         this.unseenMentionForViewerMessages.push(message.messageId);
//       }
//
//       // do the same for all message.replies
//       if (message.replies) {
//         message.replies = message.replies.map(reply => {
//           const formatted = Object.keys(reply).reduce((acc, key) => {
//             acc[key.replace(/_([a-z])/g, g => g[1].toUpperCase())] = reply[key];
//             return acc;
//           }, {});
//
//           try {
//             formatted.segments = JSON.parse(formatted.message);
//           } catch (e) {
//             // do nothing
//           }
//
//           if (reply["containsUnreadMentionForViewer"]) {
//             this.unseenMentionForViewerMessages.push(reply.messageId);
//           }
//
//           return formatted;
//         });
//       }
//
//       if (!this.allMessages[message.messageId]) {
//         this.allMessages[message.messageId] = message;
//         if (!message.parentId) {
//           if (appendToFront) {
//             this.orderedMessages.unshift(message.messageId);
//           } else {
//             this.orderedMessages.push(message.messageId);
//           }
//         } else {
//           this.updateReply(message);
//         }
//       } else {
//         if (!message.parentId) {
//           const originalReplies = Object.assign([], toRaw(this.allMessages[message.messageId].replies || []));
//           this.allMessages = {
//             ...this.allMessages,
//             [message.messageId]: {
//               ...this.allMessages[message.messageId],
//               ...message,
//               replies: originalReplies,
//             },
//           };
//         } else {
//           this.updateReply(message);
//         }
//       }
//     },
//
//     messageContainsUnreadMentionForViewer(messageId) {
//       return this.unseenMentionForViewerMessages.includes(messageId);
//     },
//
//     getMessageFromError(error) {
//       if (error.message && error.message === "something specific happened") {
//         return "something specific happened";
//       }
//       return "something went wrong";
//     },
//
//     resetConversation() {
//       this.allMessages = {};
//       this.orderedMessages = [];
//       this.conversation = {};
//       this.lastMessageId = null;
//       this.lastSortId = null;
//     },
//
//     updateConversation(conversationSummary, messages, metadata, newMessage) {
//       this.conversation = conversationSummary;
//       messages.forEach(message => {
//         if (this.includeDeletedMessages || message.status !== "inactive") {
//           this.addOrReplaceMessage(message, newMessage);
//         }
//       });
//       if (metadata && metadata.lastMessageId && metadata.lastSortId) {
//         this.lastMessageId = metadata.lastMessageId;
//         this.lastSortId = metadata.lastSortId;
//       }
//     },
//     openCommentInput() {
//       this.isCommentInputOpen = true;
//     },
//     closeCommentInput() {
//       this.isCommentInputOpen = false;
//     },
//     cancelComment() {
//       this.comment = "";
//       this.closeCommentInput();
//     },
//     isReplyInputOpen(messageId) {
//       return this.replyInputs[messageId];
//     },
//     openReplyInput(messageId) {
//       this.replies[messageId] = "";
//       return this.replyInputs[messageId] = true;
//     },
//     closeReplyInput(messageId) {
//       return this.replyInputs[messageId] = false;
//     },
//     cancelReply(messageId) {
//       this.replies[messageId] = "";
//       this.closeReplyInput(messageId);
//     },
//     createReplyForComment(messageId) {
//       const generalStore = useGeneralStore();
//       if (!generalStore.isLoggedIn) {
//         generalStore.setRedirectLocation(window.location.href);
//         generalStore.redirectTo("/login");
//         return;
//       }
//
//       this.apiPost(`/message/${messageId}/reply`, {
//         message: this.replies[messageId],
//         moderation_strategy: this.moderationStrategy,
//       }, data => {
//         this.isMessageLoading.newMessage = false;
//         this.updateMessages(data.messages, true);
//       });
//     },
//     createSupportConversation(firstName, lastName, email, message, successHandler = () => {
//     }, errorHandler = () => {
//     }) {
//       this.loadingCreateSupportConversation = true;
//       this.apiPost(`/conversation/publication/${useConfigurationStore().publicationId}/contact-us`, {
//         first_name: firstName,
//         last_name: lastName,
//         email,
//         message,
//       }, data => {
//         this.conversation.conversation_id = data.conversation_id;
//         successHandler(data);
//       }, err => {
//         errorHandler(err);
//       }, () => {
//         this.loadingCreateSupportConversation = false;
//       });
//     },
//     getConversationFormattedMessage(errorMessage) {
//       switch (errorMessage) {
//         case "you cannot report a message more than once":
//           return "You cannot report a message more than once";
//         case "Cannot remove vote more than once.":
//           return "You cannot remove a vote more than once";
//         default:
//           return "Something went wrong with request.";
//       }
//     },
//   },
// });
